/**
 * Sets window globals for UMD libraries (Foundation, select2, FullCalendar, etc.)
 * MUST be loaded as a side-effect before all other imports.
 *
 * Usage in entry points:
 *   import "../vendor/globals.js";  // ← MUST come FIRST!
 */
import $ from "jquery";
import _ from "underscore";
import Backbone from "backbone";
import moment from "moment/min/moment-with-locales";

window.$ = window.jQuery = $;
window._ = _;
window.Backbone = Backbone;
window.moment = moment;
Backbone.$ = $;

// Dynamically load FullCalendar v3 (Webpack UMD) + moment-recur
(function () {
  var s = document.createElement("script");
  s.src = "/vendor/fullcalendar.min.js";
  document.head.appendChild(s);
  s = document.createElement("script");
  s.src = "/vendor/moment-recur.js";
  document.head.appendChild(s);
})();
